import React from "react";
import * as RadioGroup from "@radix-ui/react-radio-group";
import { RadioButtonGroupProps } from "./types";
import { RadioButton } from "./RadioButton";
import { optionsWrapperClass } from "./RadioButtonGroup.css";
import { getDir } from "@learningblocks/shared-components/lib/Translations";
import { useIntl } from "react-intl";

export const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options,
  selectedOptionIndex,
  submittedOptionIndexes = [],
  answerId,
  onOptionSelect,
  ariaLabelledby,
  showFeedbackOnSubmit = true,
  resetCount,
}) => {
  const charCodeA = "A".charCodeAt(0);

  const handleValueChange = (value: string) => {
    onOptionSelect?.(parseInt(value, 10));
  };

  const mostRecentlySubmittedId =
    submittedOptionIndexes.length > 0
      ? submittedOptionIndexes[submittedOptionIndexes.length - 1]
      : undefined;

  const intl = useIntl();
  return (
    <RadioGroup.Root
      className={optionsWrapperClass}
      value={
        selectedOptionIndex !== undefined ? selectedOptionIndex.toString() : ""
      }
      onValueChange={handleValueChange}
      aria-labelledby={ariaLabelledby}
      dir={getDir(intl.locale)}
    >
      {options.map((option, index) => {
        const isCorrect = answerId.includes(option.id);
        const isMostRecentlySubmitted = option.id === mostRecentlySubmittedId;
        return (
          <RadioButton
            key={option.id}
            option={option}
            displayLabel={String.fromCharCode(charCodeA + index)}
            isSelected={selectedOptionIndex === option.id}
            isSubmitted={submittedOptionIndexes.includes(option.id)}
            isCorrect={isCorrect}
            showFeedbackOnSubmit={showFeedbackOnSubmit}
            isMostRecentlySubmitted={isMostRecentlySubmitted}
            resetCount={resetCount}
          />
        );
      })}
    </RadioGroup.Root>
  );
};

export default RadioButtonGroup;
